module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid fld"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.panelFlag) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12 fld"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Contract Details")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back to Contracts")])]), _vm._v(" "), (_vm.viewContractPanel) ? _c('div', [_c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title hidden-md hidden-lg"
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Service Provider: " + _vm._s(_vm.contract.contract_cnpro)), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Contract Status:")]), _vm._v(" "), _c('span', {
    staticClass: "status-flag",
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.4em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])])]), _vm._v(" "), _c('h3', {
    staticClass: "page-title hidden-xs hidden-sm"
  }, [_vm._v("\r\n                                                                    Service Provider: " + _vm._s(_vm.contract.contract_cnpro) + "\r\n                                                                    "), _c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("Contract Status:")]), _vm._v(" "), _c('span', {
    staticClass: "status-flag",
    style: ({
      background: _vm.contract.contract_status_color_code,
      color: '#fff',
      padding: '0.4em'
    })
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left hidden-lg hidden-md"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenuActions
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v("View Actions")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu-actions"
  }, [(_vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewQuote(_vm.contract.contract_cnpro)
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-thread', '')
      }
    }
  }, [_vm._v("View Discussion")]), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id != 3 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#complaint"
    }
  }, [_vm._v("Make A Complaint")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id == 3 || _vm.contract.contract_status_id == 6) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeContract
    }
  }, [_vm._v("End / Close Contract Request")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" View Uploaded Work Pictures")]) : _vm._e(), _c('br')]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view-thread', '')
      }
    }
  }, [_vm._v("View Discussion")]), _vm._v(" "), (_vm.contract.contract_status_id != 3) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewQuote(_vm.contract.contract_cnpro)
      }
    }
  }, [_vm._v("View Quote")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id != 3 && _vm.contract.contract_status_id != 6 && _vm.contract.contract_status_id != 7 && _vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#complaint"
    }
  }, [_vm._v("Make A Complaint")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 3 || _vm.contract.contract_status_id == 6) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeContract
    }
  }, [_vm._v("End / Close Contract Request")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8 || _vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "submit",
      "data-toggle": "modal",
      "data-target": "#contract_pictures"
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" View Uploaded Work Pictures")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.contract.contract_status_id == 5) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), (_vm.contract.contract_status_id == 5) ? _c('p', [_vm._v("You have Confirmed that this Work has been carrried out "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Notice!: ")]), _vm._v("Your 48hrs time frame to report any issue regarding this works ends on "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.contract.contract_expiry_date))])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 4) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Work should be in progress, if work is completed, confirm by clicking the button below")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Confirm / Approve Work")])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 8) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Work has been confirmed by CNpro, if work is completed, confirm by clicking the button below")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Confirm / Approve Work")])]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_contract_complaints && _vm.contract.contract_contract_complaints == 16) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("------------------------------------------------")]), _vm._v(" "), _c('p', [_vm._v("Please resolve all pending disputes (see below). If resolved, please hold on while Admin verifies CNuser job satisfaction. Thank you")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Complaints Made ")]), _vm._v(" "), _vm._l((_vm.contract.contract_contract_complaints), function(complaint, index) {
    return _c('div', [_c('p', [_vm._v(" " + _vm._s(++index) + ") " + _vm._s(complaint.contract_complaint) + " \r\n                                                                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(complaint.contract_complaint_date) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), (complaint.contract_complaint_status == 15) ? _c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v("RESOLVED")]) : _c('button', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.resolveComplaint(complaint, complaint.contract_complaint_id)
        }
      }
    }, [_vm._v("Resolve Complaint")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.contract.contract_status_id == 5 || _vm.contract.contract_status_id == 12) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.contract.contract_ratings.length == 0 && _vm.contract.contract_reviews.length != 0) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("Rate Service Provider")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_reviews.length == 0) ? _c('div', [(_vm.contract.contract_reviews.length == 0) ? _c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Review CNpro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.canRate) ? _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(_vm.contract.contract_cnpro_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.contract.contract_reviews), function(review) {
    return _c('p', [_vm._v("\r\n                                                                                       " + _vm._s(review.contract_review_review) + "\r\n                                                                                   ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group input-rating col-sm-3"
  }, _vm._l((_vm.contract.contract_ratings), function(rate) {
    return _c('p', [_c('b', [_vm._v("You Rated:  \r\n                                                                                         "), _vm._l((rate.contract_rating_rate), function(r) {
      return _c('i', {
        staticClass: "fa fa-star",
        staticStyle: {
          "color": "goldenrod"
        }
      })
    }), _vm._l(((5 - rate.contract_rating_rate)), function(r) {
      return _c('i', {
        staticClass: "fa fa-star-o",
        staticStyle: {
          "color": "goldenrod"
        }
      })
    })], 2)])
  }))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.viewContractThread) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Discussion\r\n                                                            "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _vm._l((_vm.contract.contract_contract_threads), function(thread) {
    return [_c('p', [_c('b', [_vm._v(_vm._s(thread.contract_thread_user_name) + ":")]), _vm._v(" " + _vm._s(thread.contract_thread_thread) + " ")])]
  }), _vm._v(" "), (_vm.contract.contract_status_id != 5) ? _c('form', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.message),
      expression: "contract.message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Message",
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.replyContract(_vm.contract.contract_id, _vm.user.user_id)
      }
    }
  }, [_vm._v("Send")])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.viewQuote) ? _c('div', {
    staticClass: "background-white p20 mb30"
  }, [_c('h3', {
    staticClass: "page-title"
  }, [_vm._v("Quote Details\r\n                                                                        "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('view', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details/Description:")]), _vm._v(" " + _vm._s(_vm.contract.contract_quote_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Material Detail:")]), _vm._v(" " + _vm._s(_vm.contract.contract_material_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Labour Cost:")]), _vm._v(" ₦" + _vm._s(_vm.contract.contract_labour_cost))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Work Duration:")]), _vm._v(" " + _vm._s(_vm.contract.contract_work_duration) + " Days")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id == 6) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.preAcceptQuote(_vm.contract)
      }
    }
  }, [_vm._v("Accept Quote")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.rejectQuote(_vm.contract.contract_id)
      }
    }
  }, [_vm._v("Reject Quote")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-offset-3",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), ((_vm.contracts.length == null)) ? _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Contracts Request Yet")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contracts), function(co, index) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12 col-xs-12",
      staticStyle: {
        "padding": "1em",
        "border-bottom": "solid 1px rgb(230, 225, 225)"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setPanel('viewContract', co.contract_id)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 col-sm-10 col-xs-8",
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', [_vm._v(_vm._s(co.contract_cnpro))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(co.contract_ref))]), _vm._v(" "), _c('span', {
      style: ({
        background: co.contract_status_color_code,
        color: '#fff',
        padding: '0.2em'
      })
    }, [_vm._v(_vm._s(co.contract_status))]), _vm._v(" "), (co.contract_status_id == 12) ? _c('span', [_vm._v(" - " + _vm._s(co.contract_job_status))]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        background: co.contract_complaint_status_color_code,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(co.contract_complaint_status_name))])])])])
  })], 2)])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "complaint",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "height": "300px"
    }
  }, [_vm._m(3), _c('br'), _vm._v(" "), _c('div', {}, [_c('h3', [_vm._v("Make a complaint on the Job carried out")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.complaint),
      expression: "contract.complaint"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Message",
      "name": "",
      "id": "",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.contract.complaint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract.complaint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: " btn btn-primary btn-xl",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.makeComplaint(_vm.contract.contract_id, _vm.user.user_id)
      }
    }
  }, [_vm._v("Send")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "contract_pictures",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Uploaded Work Pictures")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_1
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_2
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "border-bottom": "#22baae dashed 2px"
    }
  }, [_vm._m(6), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.contract.contract_work_image_3
    }
  })])]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "2em"
    },
    attrs: {
      "id": "reviewModal",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('form', {
    staticClass: "background-white p20 add-review"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Review CNpro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Your Review")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.review),
      expression: "review.review"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.review.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.review.review = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.canRate) ? _c('div', {
    staticClass: "form-group input-rating col-sm-12"
  }, [_c('div', {
    staticClass: "rating-title"
  }, [_vm._v("What's your rating?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateValue, 1)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-1"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "id": "rating-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateValue, 2)
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = 2
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-2"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "rating-3"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "3")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-3"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "rating-4"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "4")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateValue),
      expression: "rateValue"
    }],
    attrs: {
      "type": "radio",
      "value": "5",
      "id": "rating-5"
    },
    domProps: {
      "checked": _vm._q(_vm.rateValue, "5")
    },
    on: {
      "__c": function($event) {
        _vm.rateValue = "5"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating-5"
    }
  }), _vm._v(" "), (_vm.rate) ? _c('span', [_vm._v("You rated"), _c('b', [_vm._v(" " + _vm._s(_vm.rate) + " ")]), _vm._v(" Thanks!")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitReview(_vm.contract.contract_cnpro_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v("Submit Review")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.selected_contract.contract_labour_cost))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.selected_contract.contract_labour_cost) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.acceptQuote('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.acceptQuote('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Your Review")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("Contracts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-4"
  }, [_c('i', {
    staticClass: "fa fa-file-o",
    staticStyle: {
      "padding": "0.1em",
      "font-size": "4.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "2em",
      "color": "#000"
    }
  }, [_c('b', [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 1 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 2 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Work Image 3 >> ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1c358e6"}!./src/components/Contracts/template.html
// module id = 317
// module chunks = 0